<div class="flex" [ngClass]="{'sidebar-active': app.sidebarActive}">
	<div class="sidebar-next-right-block">
		<div class="partner-right-block-body">
			<div>
				<div class="flex flex-row">
					<div *ngIf="activeDocumentItem === documentTypeEnum.SECDocument" class="settings-legal-document-label">SEC Document</div>
					<div *ngIf="activeDocumentItem === documentTypeEnum.BIR2303" class="settings-legal-document-label">BIR 2303</div>
					<div *ngIf="activeDocumentItem === documentTypeEnum.BusinessPermit" class="settings-legal-document-label">Business Permit</div>
					<div style="margin-left: auto">
						<button [disabled]="true" (click)="handleShowDocumentStatus()" class="p-button-outlined" style="width: 123px; height: 45px;" pButton label="View Status"></button>
					</div>
					<div style="margin-left: 20px;">
						<button [disabled]="true" (click)="handleShowDocumentUpdate()" class="btn-darkblue" style="width: 123px; height: 45px;" pButton label="Update"></button>
					</div>
				</div>

				<div class="flex flex-row" style="margin-top: 57px;" *ngIf="activeDocumentItem === documentTypeEnum.SECDocument">
					<div>
						<div class="settings-legal-document-input-item">
							<div class="settings-legal-document-input-label">Issue Date</div>
							<input [(ngModel)]="legalDocs.SECDocumentIssueDate" [disabled]="true" class="settings-legal-document-input" type="text" pInputText />
						</div>
						<div class="settings-legal-document-input-item">
							<div class="settings-legal-document-input-label">Document Number</div>
							<input [(ngModel)]="legalDocs.SECDocumentNumber" [disabled]="true" class="settings-legal-document-input" type="text" pInputText />
						</div>
					</div>
					<div *ngIf="legalDocs.SECDocumentImageUrl" style="margin-left: 84px;">
						<p-image [src]="legalDocs.SECDocumentImageUrl" alt="Image" width="500" [preview]="true"></p-image>
					</div>
				</div>

				<div class="flex flex-row" style="margin-top: 57px;" *ngIf="activeDocumentItem === documentTypeEnum.BIR2303">
					<div>
						<div class="settings-legal-document-input-item">
							<div class="settings-legal-document-input-label">Issue Date</div>
							<input [(ngModel)]="legalDocs.BIR2303IssueDate" [disabled]="true" class="settings-legal-document-input" type="text" pInputText />
						</div>
						<div class="settings-legal-document-input-item">
							<div class="settings-legal-document-input-label">Expiration Date</div>
							<input [(ngModel)]="legalDocs.BIR2303ExpirationDate" [disabled]="true" class="settings-legal-document-input" type="text" pInputText />
						</div>
						<div class="settings-legal-document-input-item">
							<div class="settings-legal-document-input-label">Document Number</div>
							<input [(ngModel)]="legalDocs.BIR2303Number" [disabled]="true" class="settings-legal-document-input" type="text" pInputText />
						</div>
					</div>
					<div *ngIf="legalDocs.BIR2303DocumentImageUrl" style="margin-left: 84px;">
						<p-image [src]="legalDocs.BIR2303DocumentImageUrl" alt="Image" width="500" [preview]="true"></p-image>
					</div>
				</div>

				<div class="flex flex-row" style="margin-top: 57px;" *ngIf="activeDocumentItem === documentTypeEnum.BusinessPermit">
					<div>
						<div class="settings-legal-document-input-item">
							<div class="settings-legal-document-input-label">Issue Date</div>
							<input [(ngModel)]="legalDocs.BusinessPermitIssueDate" [disabled]="true" class="settings-legal-document-input" type="text" pInputText />
						</div>
						<div class="settings-legal-document-input-item">
							<div class="settings-legal-document-input-label">Expiration Date</div>
							<input [(ngModel)]="legalDocs.BusinessPermitExpirationDate" [disabled]="true" class="settings-legal-document-input" type="text" pInputText />
						</div>
						<div class="settings-legal-document-input-item">
							<div class="settings-legal-document-input-label">Document Number</div>
							<input [(ngModel)]="legalDocs.BusinessPermitNumber" [disabled]="true" class="settings-legal-document-input" type="text" pInputText />
						</div>
					</div>
					<div *ngIf="legalDocs.BusinessPermitDocumentImageUrl" style="margin-left: 84px;">
						<p-image [src]="legalDocs.BusinessPermitDocumentImageUrl" alt="Image" width="500" [preview]="true"></p-image>
					</div>
				</div>
			</div>
		</div>

		<partnet-settings-update-legal-document [visible]="showUpdateDocument" [activeDocumentItem]="activeDocumentItem" [onHide]="handleHideDocumentUpdate"></partnet-settings-update-legal-document>
		<partner-settings-legal-document-status [visible]="showDocumentStatus" [onHide]="handleHideDocumentStatus" [activeDocumentItem]="activeDocumentItem"></partner-settings-legal-document-status>
		<p-toast position="top-right"></p-toast>
	</div>
</div>
